import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  offerRecipientsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  offerRecipientSubHead: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(1.75),
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  companyDetailRow: {
    display: 'flex',
  },
  name: {
    width: '59.6%',
  },
  agreementName: {
    width: '34.5%',
    marginLeft: theme.spacing(3),
  },
  agreementDescription: {
    marginTop: theme.spacing(3),
    width: '96%',
  },
  customEmailMessage: {
    marginTop: theme.spacing(6),
    width: '96%',
    marginBottom: theme.spacing(4.3),
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
}))
